import React, { useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import {
  DialogHeader,
  DialogHeading,
  GridLeft,
  GridRight,
  GridSection,
} from '../../Episode.Styled';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Grid, IconButton, Typography } from '@mui/material';
import { useReactToPrint } from 'react-to-print';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  dateFormat
} from '../../../../constants';
import FormInputMultiCheckbox from '../../../common/Forms/FormCheckbox';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

const RTScoringGuide = (props) => {
  const { open, setOpen, participantInfo, episode, aorcmReferenceData, oras, tot1, tot2, tot3, totORAS} = props;
  //console.log('### participantInfo')
  //console.log(participantInfo)
  //console.log('### oras')
  //console.log(oras)
  //console.log('### aorcmReferenceData')
  //console.log(aorcmReferenceData)

  const handleClose = () => {
    setOpen(false);
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <Dialog fullScreen open={open} onClose={setOpen}>
      <DialogHeader>
        <DialogHeading variant="h5"></DialogHeading>
        <Box>
          <Button variant="contained" onClick={() => handlePrint()}>
            Print
          </Button>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogHeader>
        <Box px={4}>
        <Grid container spacing={1} ref={componentRef} sx={{paddingTop: '40px;', paddingLeft: '40px;', paddingRight: '40px;', width: '1200px;'}}>
            <Grid item xs={2}>
              <Box
                component="img"
                sx={{
                  display: 'flex', 
                  justifyContent: 'center',
                  height: 100,
                  width: 100,
                  maxHeight: { xs: 100, md: 100 },
                  maxWidth: { xs: 100, md: 100 },
                }}
                src="/westcare-logo.jpg"
              />
            </Grid>  
            <Grid item xs={10}>
              <Typography sx={{ textAlign: 'center' }} pt={5} variant="h5">ORAS - SCORING FOR THE COMMUNITY SUPERVISION TOOL (RT)</Typography>
              <Typography sx={{ textAlign: 'center', 'backgroundColor': 'yellow' }} variant="h5" >Individuals released from prison within the last 90 days and were in prison 4 years or more</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography variant="h5">Name: {participantInfo.key}</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ textAlign: 'right' }} variant="h5">Date of Assessment: {oras?.epdOrasAssessDate ? moment(oras?.epdOrasAssessDate).format(dateFormat) : ''}</Typography>
            </Grid>

            <Grid item xs={5}>
              <Typography variant="h5">CDC#: {episode.cDCNumber}</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography sx={{ textAlign: 'right' }} pb={2} variant="h5">Community Service Specialist: {oras?.epdOrasCSSID ? aorcmReferenceData.caseManagerOrCMList.find(a => a.id==oras.epdOrasCSSID).value : ''}</Typography>
            </Grid>


            { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
            <GridLeft item xs={3}>
              Calculated Risk Category MALES
              <FormGroup>
                <FormControlLabel control={              
                  <Checkbox
                    checked={totORAS<=9}
                  />}
                  label="0 - 9 Low"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totORAS >=10 && totORAS<=15}
                  />}
                  label="10 - 15 Moderate"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totORAS >=16}
                  />}
                  label="16+ High"
                />
              </FormGroup>    
            </GridLeft>
            :
            <GridLeft item xs={3}>
              Calculated Risk Category FEMALES}
              <FormGroup>
                <FormControlLabel control={              
                  <Checkbox
                    checked={totORAS<=10}
                  />}
                  label="0 - 10 Low"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totORAS >=11 && totORAS<=14}
                  />}
                  label="11 - 14 Moderate"
                />
              </FormGroup>    
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={totORAS >=15}
                  />}
                  label="15+ High"
                />
              </FormGroup>    
            </GridLeft>
            }


            <Grid item xs={3} />
            <Grid item xs={6}>
              <FormGroup>
                <FormControlLabel control={              
                  <Checkbox 
                    checked={oras?.isOverride}
                  />}
                  label="Professional Override"
                />
              </FormGroup>
              <TextField
                name='overrideReason'
                multiline={true}
                maxRows={2.5}
                type="text"
                label='Reason for Override'
                shrink={true}
                value={oras?.overrideReason}
                fullWidth
              />
              
            </Grid>             
          
          
          <Grid container>
            <Grid item xs={5} />
            <Grid item xs={1.5}>
              <Typography variant="h6">Override Level</Typography>
            </Grid>
            <Grid item xs={5.5}>
              <RadioGroup sx={{marginTop: '-8px;'}} row value={oras?.overrideLevel ?? ''}>
                <FormControlLabel
                  value='1'
                  label='LOW'
                  control={<Radio />}
                />
                <FormControlLabel
                  value='2'
                  label='MODERATE'
                  control={<Radio />}
                />
                <FormControlLabel
                  value='3'
                  label='HIGH'
                  control={<Radio />}
                />
              </RadioGroup>  
            </Grid>
          </Grid>



          <Grid item xs={12}>
            <Typography variant="h6">Recommendations;</Typography>
          </Grid>

          { participantInfo?.gender == 'M' || participantInfo?.gender?.id == 'M' ?
          <>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==1 ? '800' : '400' : totORAS<=9 ? '800' : '400'} variant="h6">LOW</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==1 ? '800' : '400' : totORAS<=9 ? '800' : '400'} variant="h6">Females: Minimum supervision or non-reporting supervision<br/>Males: Regular supervision; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==2 ? '800' : '400' : totORAS >=10 && totORAS<=15 ? '800' : '400'} variant="h6">MODERATE</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==2 ? '800' : '400' : totORAS >=10 && totORAS<=15 ? '800' : '400'} variant="h6">Enhanced supervision; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==3 ? '800' : '400' : totORAS >=16 ? '800' : '400'} variant="h6">HIGH</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==3 ? '800' : '400' : totORAS >=16 ? '800' : '400'} variant="h6">Enhanced supervision and/or residential placement; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          </>
          :
          <>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==1 ? '800' : '400' : totORAS<=10 ? '800' : '400'} variant="h6">LOW</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==1 ? '800' : '400' : totORAS<=10 ? '800' : '400'} variant="h6">Females: Minimum supervision or non-reporting supervision<br/>Males: Regular supervision; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==2 ? '800' : '400' : totORAS >=11 && totORAS<=14 ? '800' : '400'} variant="h6">MODERATE</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==2 ? '800' : '400' : totORAS >=11 && totORAS<=14 ? '800' : '400'} variant="h6">Enhanced supervision; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==3 ? '800' : '400' : totORAS >=15 ? '800' : '400'} variant="h6">HIGH</Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography fontWeight={oras?.isOverride ? oras?.overrideLevel==3 ? '800' : '400' : totORAS >=15 ? '800' : '400'} variant="h6">Enhanced supervision and/or residential placement; programming should be provided for moderate and high need domains</Typography>
          </Grid>
          </>
          }

          <Grid item xs={12}>
            <Typography pt={1} variant="h6">Other Areas of Concern. Ckeck all that apply.</Typography>
          </Grid>
          <Grid item xs={12}>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_LowIntelligence}
                />}
                label="Low Intelligence"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_PhysicalHandicap}
                />}
                label="Physical Handicap"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_ReadWriteLimits}
                />}
                label="Read/Writing"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_MentalHealth}
                />}
                label="Mental Health"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_NoDesire}
                />}
                label="No Desire to Change"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Transportation}
                />}
                label="Transportation"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_ChildCare}
                />}
                label="Child Care"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Language}
                />}
                label="Language"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Ethnicity}
                />}
                label="Ethnicity"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Cultural}
                />}
                label="Cultural Barriers"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Cultural}
                />}
                label="History of Abuse/Neglect"
              />
            </FormGroup>
            <FormGroup sx={{marginTop: '-12px;'}}>
              <FormControlLabel control={              
                <Checkbox
                  checked={oras?.other_Interpersonal}
                />}
                label="Interpersonal Anxiety"
              />
            </FormGroup>
            </Grid>
            <Grid item xs={1}>
              <FormGroup sx={{marginTop: '-18px;'}}>
                <FormControlLabel control={              
                  <Checkbox
                    checked={oras?.other_Other}
                  />}
                  label="Other"
                />
              </FormGroup>
            </Grid>
            <Grid item xs={11}>    
              <TextField
                size="small"
                sx={{marginTop: '-16px;'}}
                name='overrideReason'
                type="text"
                label=''
                shrink={true}
                value={oras?.other_OtherDescr}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h5">* If these items are checked it is strongly recommended that forther assessment be conducted to determine level or severity.</Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography pt={1} variant="h5" sx={{fontWeight: '800'}}>Level of Need</Typography>
            </Grid>

            <GridLeft item xs={3}>
              <Typography variant="h5">HIGH</Typography>
              <Typography pt={1} variant="h5">MOD</Typography>
              <Typography pt={1} variant="h5">LOW</Typography>
            </GridLeft>
            <GridLeft item xs={3}>
              <Typography sx={{ textAlign: 'center', border: (tot1 >=7 && tot1 <=12 ? '1px solid' : 'none')}} variant="h5">7-12</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot1 >=4 && tot1 <=6 ? '1px solid' : 'none')}} pt={1} variant="h5">4-6</Typography>
              <Typography sx={{ textAlign: 'center',  border: (tot1 >=0 && tot1 <=3 ? '1px solid' : 'none')}} pt={1} variant="h5">0-3</Typography>
            </GridLeft>
            <GridLeft item xs={3}>
              <Typography sx={{ textAlign: 'center', border: (tot2 >=3 && tot2 <=4 ? '1px solid' : 'none') }} variant="h5">3-4</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot2 ==2 ? '1px solid' : 'none') }} pt={1} variant="h5">2</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot2 >=0 && tot2 <=1 ? '1px solid' : 'none') }} pt={1} variant="h5">0-1</Typography>
            </GridLeft>
            <GridLeft item xs={3}>
              <Typography sx={{ textAlign: 'center', border: (tot3 >=7 && tot3 <=11 ? '1px solid' : 'none') }} variant="h5">7-11</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot3 >=4 && tot3 <=6 ? '1px solid' : 'none') }} pt={1} variant="h5">4-6</Typography>
              <Typography sx={{ textAlign: 'center', border: (tot3 >=0 && tot3 <=3 ? '1px solid' : 'none') }} pt={1} variant="h5">0-3</Typography>
            </GridLeft>

            <GridLeft minHeight={300} item xs={3}>
            </GridLeft>
            <GridLeft minHeight={300} item xs={3}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Criminal History</Typography>
            </GridLeft>
            <GridLeft minHeight={300} item xs={3}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Social Bonds</Typography>
            </GridLeft>
            <GridLeft minHeight={300} item xs={3}>
              <Typography variant="h5" sx={{textAlign: 'center', mt: '50%', transform: 'rotate(90deg)'}}>Criminal Attitudes and Behavioral Patterns</Typography>
            </GridLeft>

            <Grid item xs={1}>
              <Typography variant="h5">Total</Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="h5" sx={{textAlign: 'center', border: '1px solid'}}>{totORAS}</Typography>
            </Grid>

          </Grid>

        
      </Box>
    </Dialog>
  );
};

export default RTScoringGuide;

RTScoringGuide.defaultProps = {
  open: false,
  setOpen: () => {},
};

RTScoringGuide.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};
